import React from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Section1 from "../components/tvfirestick/section1";
import Tutorial from "../components/tvfirestick/tutorial";
import Section3 from "../components/tvfirestick/section3";
import Question from "../components/tvfirestick/question";
import Footer from "../components/navigation/Footer";

const InstallFireStick = ({strellatv}) => {
    return (
        <Layout>

            {strellatv &&
                (
                    <>
                        <Section1 data={strellatv}/>
                        <Tutorial data={strellatv}/>
                        <Section3/>
                        <Question/>
                        <Footer/>
                    </>
                )
            }


        </Layout>
    );
};


const mapStateToProps = state => ({
    strellatv: state.Home.strellatv,
})

export default connect(mapStateToProps, {})(InstallFireStick)
